import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { DeviceType, SpaceBetweenColumnsType } from '../typings';
import { IThreeColumnGridProps } from '../components/three-column-grid/three-column-gird';

export class ThreeColumnGridModel extends ContentItem {
  get containItems(): IKontentItem[] {
    return get(this._config, 'elements.contain_items.value', []);
  }

  get marginBetweenItems(): SpaceBetweenColumnsType {
    return get(
      this._config,
      'elements.margin_between_items__choose.value[0].codename',
      ''
    );
  }

  get wrappTwoColumns(): DeviceType {
    return get(
      this._config,
      'elements.wrapp_two_columns.value[0].codename',
      ''
    );
  }

  get wrappOneColumn(): DeviceType {
    return get(this._config, 'elements.wrapp_one_column.value[0].codename', '');
  }

  get sameColumnsWidth(): boolean {
    return (
      get(this._config, 'elements.same_columns_width.value[0].codename', '') ===
      'true'
    );
  }

  public static create(data: IThreeColumnGrid): IThreeColumnGridProps {
    const {
      containItems,
      marginBetweenItems,
      wrappTwoColumns,
      wrappOneColumn,
      sameColumnsWidth
    } = new ThreeColumnGridModel(data);
    return {
      containItems,
      marginBetweenItems,
      wrappTwoColumns,
      wrappOneColumn,
      sameColumnsWidth
    };
  }
}
